// extracted by mini-css-extract-plugin
module.exports = {"detailsText":"DetailsText_detailsText__13Oua"};